import { MyPointsIcon } from "@hm-group/fabric-icons/icons/MyPointsIcon";
import { AccountDefaultIcon } from "@hm-group/fabric-icons/icons/AccountDefaultIcon";
import { PayLaterIcon as PayLaterIconNS } from "@hm-group/fabric-icons/icons/PayLaterIcon";
import { CustomerServiceIcon as CustomerServiceIconNS } from "@hm-group/fabric-icons/icons/CustomerServiceIcon";
import { LogoutIcon } from "@hm-group/fabric-icons/icons/LogoutIcon";
import { CustomerServiceFeedbackIcon } from "@hm-group/fabric-icons/icons/CustomerServiceFeedbackIcon";
import { SettingsIcon } from "@hm-group/fabric-icons/icons/SettingsIcon";
import { PaymentIcon } from "@hm-group/fabric-icons/icons/PaymentIcon";
import { RatingInactiveIcon } from "@hm-group/fabric-icons/icons/RatingInactiveIcon";
import { InviteAFriendIcon as InviteAFriendIconNS } from "@hm-group/fabric-icons/icons/InviteAFriendIcon";
import { DeliveryIcon } from "@hm-group/fabric-icons/icons/DeliveryIcon";
import { WelcomePointsIcon, ParcelIcon, InviteAFriendIcon, PayLaterIcon, PersonIcon, CustomerServiceIcon, NewWindowIcon, HelpUsImproveIcon, } from "../Icon";
export const icons = {
    ParcelIcon,
    DeliveryIcon,
    WelcomePointsIcon,
    MyPointsIcon,
    SettingsIcon,
    PaymentIcon,
    PersonIcon,
    RatingInactiveIcon,
    InviteAFriendIcon,
    PayLaterIcon,
    CustomerServiceIcon,
    NewWindowIcon,
    HelpUsImproveIcon,
    AccountDefaultIcon,
    PayLaterIconNS,
    CustomerServiceIconNS,
    InviteAFriendIconNS,
    LogoutIcon,
    CustomerServiceFeedbackIcon,
};
//# sourceMappingURL=constants.js.map